import { client } from '@/client';
import {
  CampaignTemplate,
  CreateReconAiCampaignRequest,
  GenerateReconAiCampaignTemplate,
} from '@/client/campaigns';
import { MessageResponseModel } from '@/client/models';
import {
  CreateReconAiCampaignMutation,
  GenerateReconAiCampaignTemplateMutation,
  GenericForbiddenApiError,
} from '@/hooks/query';
import { useMutation } from 'react-query';

const queryKey = 'reconAi';

export const useCreateReconAiCampaign = (): {
  create: (
    payload: CreateReconAiCampaignRequest & { accountId: string },
  ) => Promise<MessageResponseModel>;
} & Omit<CreateReconAiCampaignMutation, 'mutateAsync'> => {
  const { mutateAsync, ...rest } = useMutation<
    MessageResponseModel,
    GenericForbiddenApiError,
    CreateReconAiCampaignRequest & { accountId: string }
  >(queryKey, (payload) => {
    const { accountId, ...requestPayload } = payload;
    return client.reconAi.createReconAiCampaign(
      accountId,
      requestPayload as CreateReconAiCampaignRequest,
    );
  });

  return { create: mutateAsync, ...rest };
};

export const useGenerateReconAiCampaignTemplate = (): {
  generate: (
    payload: GenerateReconAiCampaignTemplate & { accountId: string },
  ) => Promise<CampaignTemplate>;
} & Omit<GenerateReconAiCampaignTemplateMutation, 'mutateAsync'> => {
  const { mutateAsync, ...rest } = useMutation<
    CampaignTemplate,
    GenericForbiddenApiError,
    GenerateReconAiCampaignTemplate & { accountId: string }
  >(`${queryKey}GenerateCampaignTemplate`, (payload) => {
    const { accountId, ...requestPayload } = payload;
    return client.reconAi.generateReconAiCampaignTemplate(
      accountId,
      requestPayload as GenerateReconAiCampaignTemplate,
    );
  });

  return { generate: mutateAsync, ...rest };
};
